import React, {Component} from "react"
import PropTypes from "prop-types"
import {Link} from "react-router-dom"
import {Row, Col, Button} from "elemental-react16"
import Price from "../Price/Price"
import "./ProductColDetail.scss"
import ButtonLove from "../Button/ButtonLove"
import Badge, {PillBadges} from "../Product/Badge"

import shop from "shop/shop"

export default class ProductColDetail extends Component {
  state = {
    inCart: false
  }

  componentWillMount() {
    this.updateInCart()
    shop.cart.hooks.changed.add( this.updateInCart )
  }

  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateInCart )
  }

  componentWillReceiveProps(props) {
    this.updateInCart( props.product )
  }

  updateInCart = (product) => {
    if ( !(product && product.map_id) ) product = this.props.product
    let inCart = shop.cart.contains( product )
    this.setState( { inCart } )
  }

  addToCart = () => {
    let { product } = this.props
    product.count   = product.count || 1
    shop.cart.add( product )
    this.setState( { inCart: true } )
    shop.toast( `${product.count}x ${product.title} im Warenkorb`, "info", false, "bottom" )
  }

  render() {
    let { product, sm, md, xs, lg } = this.props
    let { inCart }                  = this.state
    let inCartClass                 = (inCart ? "active" : "")
    return (
      <Col {...{ sm, md, xs, lg }}
           className="product product-col product-col-detail">
        <div className="content">
          {/*<Badge product={product}/>*/}
          <Row className="items-center">
            {/*Image*/}
            <Col sm="1/2" className="product-image-container">
              <div className="image text-center">
                <Link to={`/product/${product.map_id}`}>
                  <img src={product.img_src}
                       alt="..."
                       title=""
                       className="img-responsive"/>
                </Link>
              </div>
            </Col>

            {/*Product Description */}
            <Col sm="1/2">
              <div className="caption ">
                <div className="brand"><Link to={`/brand/${product.extras.herst}`}>{product.extras.herst}</Link></div>
                <div className="title pb3" title={product.desc.short_des}><strong><Link to={`/product/${product.map_id}`}>{product.desc.short_des}</Link></strong>
                </div>
                <div className="description">{product.desc.des}</div>
                <div className="availability pt2 pb2">{product.getNotice( "small" )}</div>
                <div className="price">
                  <Price>{product.price}</Price>
                </div>
                <div className="cf">
                  <div className="art-nr pb3 fl">
                    Art.-Nr. {product.article_nr}
                  </div>

                  <div className="pb3 fr">
                    <PillBadges product={product}/>
                  </div>
                </div>
                {product.canBeBought && <div className="actions">
                  <ButtonLove list={shop.orderlist.default}
                              className="dib mr3"
                              elementInActive={<span>Auf Merkliste</span>}
                              elementActive={<span>Auf Merkliste</span>}
                              product={product}/>
                  <Button className={`btn-love ${inCartClass}`} type="link" onClick={this.addToCart}>
                    <i className="icon-basket"/>
                    Warenkorb
                  </Button>
                </div>}
                {/*<div className="button-group">*/}
                {/*<button className="btn-primary" type="button"><span>ADD TO CART</span></button>*/}
                {/*<div className="add-to-links">*/}
                {/*<button type="button" data-toggle="tooltip" title=""*/}
                {/*data-original-title="Add to Wish List"><i className="fa fa-heart"></i>*/}
                {/*<span>Add to Wish List</span></button>*/}
                {/*</div>*/}
                {/*</div>*/}
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    )
  }
}

ProductColDetail.defaultProps = {
  xs: "1", sm: "1", md: "1", lg: "1/2",
}

ProductColDetail.propTypes = {
  product: PropTypes.object, xs: PropTypes.string, sm: PropTypes.string, md: PropTypes.string, lg: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Product/ProductColDetail.js